export const state = () => ({
  mobileMenuValue: false,
})

export const getters = {
  getMobileMenuValue: s => s.mobileMenuValue
}

export const mutations = {
  changeMobileMenuValue(state, value) {
    state.mobileMenuValue = value
  }
}
